
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Async } from '@/utils/AsyncDecorators';
import { areaSpecieProvenienzaStore } from '@/modules/AreaSpecieProvenienza/store/areaSpecieProvenienza.store';
import moment from 'moment';
import { domainStore } from '@/modules/domains';
import { exportForm } from '../export';
import { piantaSemeMarzeService } from '../services/PiantaSemeMarzeService';

@Component({})
export default class PiantaSemeMarzeItem extends Vue {

  @Prop()
  item: server.PiantaSemeMarze;

  @Async({ async get() { return (await (await areaSpecieProvenienzaStore.getters.get(this.item.areaSpecieProvenienzaId)).nome); }, default: [], lazy: true })
  areaSpeciaProvenienza: string;

  private startX: number = 0;
  private move: number = 0;
  private rowElement: any = null;

  private buttonRowLeftWidth: any = null;
  private buttonRowRightWidth: any = null;


  @Async({ async get() { return (await areaSpecieProvenienzaStore.getters.getAll()).sort((a, b) => a.nome.localeCompare(b.nome)); }, default: [], lazy: true })
  areeSpecieProvenienza: server.areaSpecieProvenienza[];

  @Async({ async get() { return await domainStore.getters.tipiPianteSemeMarze(); }, default: [], lazy: true })
  tipiPianteSemeMarze: domains.domini[];

  @Async({ async get() { return await domainStore.getters.specieArboree(); }, default: [], lazy: true })
  specieArboree: domains.domini[];
  public async start(e) {
    this.rowElement = this.$refs.rowContent;
    this.buttonRowLeftWidth = (this.$refs.buttonRowSwipeLeft as any)?.offsetWidth ? (this.$refs.buttonRowSwipeLeft as any)?.offsetWidth -20 : 0;
    this.buttonRowRightWidth = (this.$refs.buttonRowSwipeRight as any)?.offsetWidth ? (this.$refs.buttonRowSwipeRight as any)?.offsetWidth - 20 : 0;
    this.startX = e.touches[0].clientX;
  }

  get specie() {
    if (this.item.specie && this.specieArboree.length != 0) {
      return this.specieArboree.find(f => f.id === this.item.specie).label;
    }
    return null;
  }


  public onswipe(e) {
    (this.$refs.buttonRowSwipeLeft as any).style = "visibility: visible;";
    (this.$refs.buttonRowSwipeRight as any).style = "visibility: visible;";
    this.move = e.touches[0].clientX - this.startX;
    if (this.move >= 0) {
      
      (this.$refs.buttonRowSwipeRight as any).style = "visibility: hidden";
      // (this.$refs.buttonRowSwipeLeft as any).style = "visibility: visible;";
      if (this.move <= this.buttonRowLeftWidth) {
        this.rowElement.style.transform =
          "translate(" + this.move + "px" + ")";
      } else {
        this.rowElement.style.transform = "translate(" + this.buttonRowLeftWidth + "px)";
      }
    }

    if (this.move < 0) {
      (this.$refs.buttonRowSwipeLeft as any).style = "visibility: hidden;";
      // (this.$refs.buttonRowSwipeRight as any).style = "visibility: visible;";
      if (!(-this.move >= this.buttonRowRightWidth)) {
        this.rowElement.style.transform =
          "translate(" + this.move + "px" + ")";
      } else {
        this.rowElement.style.transform = "translate(-" + this.buttonRowRightWidth + "px)";
      }
    }
  }

  public onstop() {
    if (this.move >= 0) {
      if (this.move < this.buttonRowLeftWidth) {
        this.rowElement.style.transform = "translate(0)";
      }
    }
    if (this.move < 0) {
      if (!(-this.move >= this.buttonRowRightWidth)) {
        this.rowElement.style.transform = "translate(0)";
      }
    }
  }

  async edit()
  { 
    this.$emit('edit', JSON.parse(JSON.stringify(this.item)));
  }

  async exporting(type: printer.type = printer.type.pdf) {
    const detail = await piantaSemeMarzeService.Detail(this.item.id, this.item.versioneId);
    await exportForm(detail, type);  }
}